import React from 'react'

const Pagination = ({paginate, page, perPage, count, rows}) => (
  <nav>
    <ul className="pagination justify-content-end align-items-center">

      <span className="justify-content-end" style={{marginRight: '10px'}}>Showing page: {page} of {Math.ceil(count / perPage)}, and {rows.length} of {count} results</span>

      <li className={`page-item ${page === 1  ? 'disabled' : ''}`}>
        <a className="page-link" href="#" tabindex="-1" onClick={e => paginate(e, 'previous')}>Previous</a>
      </li>

      {/* If first, then show a disabled first */ }
      {page === 1 && <li className={`page-item disabled`}><a className="page-link" href="#">1</a></li>}

      {/* If last, then show two lower */}
      {(page * perPage > count && page !== 1) && <li className={`page-item`}><a className="page-link" href="#" onClick={e => paginate(e, page - 2)}>{page - 2}</a></li>}

      {/* if greater then one, then show one "lower" */}
      {page > 1 && <li className={`page-item`}><a className="page-link" href="#" onClick={e => paginate(e, page - 1)}>{page - 1}</a></li>}
      
      {/* if not first or last, then show current page in the middle */}
      {(page !== 1 && page * perPage < count) && <li className={`page-item disabled`}><a className="page-link" href="#">{page}</a></li>}
      
      {/* If not last, show one higher */}
      {page * perPage < count && <li className={`page-item`}><a className="page-link" href="#" onClick={e => paginate(e, page + 1)}>{page + 1}</a></li>}

      {/* If first, then show two higher */}
      {(page === 1 && page * perPage < count) && <li className={`page-item`}><a className="page-link" href="#" onClick={e => paginate(e, page + 2)}>{page + 2}</a></li>}

      {/* if last and not equal one, show a disabled last */}
      {(page * perPage > count && page !== 1) && <li className={`page-item disabled`}><a className="page-link" href="#">{page}</a></li>}

      <li className={`page-item ${page * perPage > count ? 'disabled' : ''}`}>
        <a className="page-link" href="#" onClick={e => paginate(e, 'next')}>Next</a>
      </li>
    </ul>
  </nav>
)

export default Pagination


// WEBPACK FOOTER //
// ./src/components/pagination/index.js